import React from 'react';
import Toast from '@applane/react-toast';
import { cancelButton, DateFilter, Text } from '../../app-components';
import { ROUTES } from '../../Lib/constants';
import vars from '../../theme/vars';
import FtsSearch from '../../Components/TableFilters/FtsSearch';
import { emailIcon, messageIcon, printerIcon } from '../../images';
import { IconButton } from '../../app-components/buttons/Buttons';
import ListAll from './All';
import { ViewAppraisal } from './View';
import { invoke } from '../../AppServices';
import { getUserRole } from '../../Lib/helpers';

const { headings } = vars;
const textStyle = { ...headings.pageHeading, marginLeft: 12 };

const viewButtonsList = (props) => {
  const arr = [];
  arr.push(cancelButton);

  if (getUserRole() === 'dealer' || getUserRole() === 'superdealer') {
    arr.push({
      render: () => (
        <IconButton
          onClick={async () => {
            window.print();
            const result = await invoke({
              id: 'handleAVPrintButton',
              paramValue: {
                appraisalId: props?.navigation?.state?.params?.item?._id,
              },
            });
            props.eventDispatcher.notify('AppraisalHistory', result);
          }}
          description="Print"
          tooltipId="printer-icon"
          style={{ usingIcon: true }}
          icon={printerIcon}
          iconStyle={{ height: 20, width: 20 }}
          stylelg={{ paddingLeft: 0, paddingRight: 0 }}
          labelStyle={{
            fontSize: 18,
            color: '#ffffff',
            fontFamily: 'Mulish-SemiBold',
          }}
        />
      ),
    });
    arr.push({
      render: () => (
        <IconButton
          onClick={async () => {
            const fromBack = await invoke({
              id: 'handleAVMessageButton',
              paramValue: {
                appraisalId: props?.navigation?.state?.params?.item?._id,
              },
            });

            Toast.show(fromBack.result);

            props.eventDispatcher.notify('AppraisalHistory', fromBack);
          }}
          description="Send Message"
          tooltipId="appraisal-generated-send-message"
          style={{ usingIcon: true }}
          icon={messageIcon}
          iconStyle={{ height: 20, width: 20 }}
          stylelg={{ paddingLeft: 0, paddingRight: 0 }}
          labelStyle={{
            fontSize: 18,
            color: '#ffffff',
            fontFamily: 'Mulish-SemiBold',
          }}
        />
      ),
    });
    arr.push({
      render: () => (
        <IconButton
          onClick={async () => {
            const fromBack = await invoke({
              id: 'handleAVMailButton',
              paramValue: {
                appraisalId: props?.navigation?.state?.params?.item?._id,
              },
            });

            if (fromBack.result) {
              const mailResultFromBack = await invoke({
                id: 'appraisalGeneratedMail',
                paramValue: {
                  appraisalId: props?.navigation?.state?.params?.item?._id,
                },
              });

              if (mailResultFromBack.statusCode === 202) {
                Toast.show({
                  message: 'Success',
                  description: 'Email Sent.',
                  type: 'success',
                  position: 'top',
                  direction: 'left',
                });
              }
            } else {
              Toast.show({
                message: 'Warning',
                description: 'Email Address Not Found',
                type: 'warning',
                position: 'top',
                direction: 'left',
              });
            }

            props.eventDispatcher.notify('AppraisalHistory', fromBack);
          }}
          description="Send Email"
          tooltipId="appraisal-generated-send-email"
          style={{ usingIcon: true }}
          icon={emailIcon}
          iconStyle={{ height: 20, width: 20 }}
          stylelg={{ paddingLeft: 0, paddingRight: 0 }}
          labelStyle={{
            fontSize: 18,
            color: '#ffffff',
            fontFamily: 'Mulish-SemiBold',
          }}
        />
      ),
    });
  }

  return arr;
};

export default {
  [ROUTES.appraisalHistoryListAll.name]: {
    screen: ListAll,
    expanded: true,
    title: () => <Text style={textStyle}>Appraisals Generated</Text>,
    headerActions: [
      (props) => (
        <FtsSearch
          {...props}
          placeholder="Search by Appraisal/VIN/Mobile/Email"
          action={{
            exp: ['repairorder', 'mobilenumber', 'email', 'vin'],
          }}
        />
      ),
      {
        render: <DateFilter field="checkDate" key="checkDate" />,
      },
    ],
  },

  [ROUTES.appraisalHistoryList.name]: {
    screen: ListAll,
    expanded: true,
    title: () => <Text style={textStyle}>Appraisals Generated</Text>,
    headerActions: [
      (props) => (
        <FtsSearch
          {...props}
          placeholder="Search by Appraisal/VIN/Mobile/Email"
          action={{
            exp: ['repairorder', 'mobilenumber', 'email', 'vin'],
          }}
        />
      ),
      {
        render: <DateFilter field="checkDate" key="checkDate" />,
      },
      cancelButton,
    ],
  },

  [ROUTES.viewAppraisalHistory.name]: {
    screen: ViewAppraisal,
    expanded: true,
    title: () => <Text style={textStyle}>View Appraisal</Text>,
    headerActions: (props) => viewButtonsList(props),
  },
};
